import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators";
import AppContainer from "./AppContainer";

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const AppReduxConnection = connect(mapStateToProps, mapDispatchToProps)(AppContainer);

export default AppReduxConnection;



/** WEBPACK FOOTER **
 ** ./src/components/AppReduxConnection.js
 **/